var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 28H10.4721C7.49861 28 5.56463 24.8707 6.89443 22.2111L13.8944 8.21115C14.572 6.85601 15.9571 6 17.4721 6H25.5076C25.8346 6 26.1604 6.04011 26.4777 6.11943L34 8M20 28V38C20 40.2091 21.7909 42 24 42H24.191C25.1901 42 26 41.1901 26 40.1909C26 38.7623 26.4229 37.3657 27.2153 36.177L34 26V8M20 28H24M34 8H38C40.2091 8 42 9.79086 42 12V24C42 26.2091 40.2091 28 38 28H33",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaints);
export default __webpack_public_path__ + "static/media/complaints.348ca1f43e1e038a71134217140eea06.svg";
export { ForwardRef as ReactComponent };